import { spacingFluidMd, spacingFluidXl } from "@porsche-design-system/components-react/emotion"
import type { InventoryAndIntakeView } from "@slfinrtl/ui-bff-routes"
import { Grid, GridItem } from "src/components"
import { IntakeInformationList } from "./intakeInformationList/IntakeInformationList"
import { InventoryInformationList } from "./inventoryInformationList/InventoryInformationList"

interface InventoryAndIntakeProps {
	view: InventoryAndIntakeView
}

export const InventoryAndIntake = ({ view }: InventoryAndIntakeProps) => {
	return (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }} $rowGap={spacingFluidMd}>
			<GridItem size={{ base: 12, m: 6 }}>
				<InventoryInformationList view={view} />
			</GridItem>
			<GridItem size={{ base: 12, m: 6 }}>
				<IntakeInformationList view={view} />
			</GridItem>
		</Grid>
	)
}
